import { useState } from "react";
import { ActionModal } from "@/app/ActionModal";
import { channels, editable, type Channel } from "@/app/master";
import { Alert, Button, KeyValue, Pill } from "@/ui";

/** Telegram 通道的回执回调（D209）：webhook_token 由服务端生成，界面只显示是否已配置（token 打码）；
 * 重新生成经二次确认后整行 PUT、webhook_token 传 null，抽屉里没保存的修改不随之提交。来源 IP 白名单 Telegram 用不上，不显示。 */
export function ChannelCallback({ row, canWrite }: { row?: Channel; canWrite: boolean }) {
  const [rotating, setRotating] = useState(false);
  if (!row) {
    // 新建通道保存即启用；回执入口没配好时 http-connector 每条提交都回通道错误（D209 第 1 条、docs/08 环境变量）。
    return (
      <Alert title="保存后自动生成回调地址">
        http-connector 发送时随请求把回调地址带给 Telegram，不用在 Telegram 后台配置。通道保存即启用：部署的回执入口（<span className="ax-mono">AXON_DLR_PUBLIC_URL</span>）没配好时，每条提交都会按通道错误失败。
      </Alert>
    );
  }
  const configured = !!row.webhook_token;
  return (
    <div className="ax-stack">
      <KeyValue items={[{
        label: "回调地址",
        value: configured ? <><Pill tone="success">已配置</Pill> <span className="ax-mono ax-secondary">/dlr/****</span></> : <><Pill>未配置</Pill> <span className="ax-secondary">保存后自动生成</span></>,
      }]} />
      {configured && canWrite && <div><Button size="sm" onClick={() => setRotating(true)}>重新生成回调地址</Button></div>}
      {rotating && (
        <ActionModal title={`重新生成通道 ${row.name} 的回调地址`} confirmLabel="重新生成" danger
          action={() => channels.update(row.id, { ...editable(row), webhook_token: null })} invalidate={["channels"]}
          message={`已重新生成通道 ${row.name} 的回调地址`} onClose={() => setRotating(false)}
          note={<>旧地址立即失效：已发出、还没收到回执的消息，Telegram 回调到旧地址时会因 token 失效而收不到，只能等 TTL 超时或 72 小时兜底收尾。抽屉里没保存的修改不会一起保存。此操作写入审计日志。</>} />
      )}
    </div>
  );
}
